import {Injectable} from '@angular/core';
import {defaultNewMemo, infoStepType, MemoAcceptData, MemoResendData, memoType} from './communications-types';
import {BehaviorSubject, Observable} from 'rxjs';
import {HttpClient} from "@angular/common/http";
import {DataSource} from "./communications.store"
import {SystemGlobalsService} from "../system-globals.service";
import {SettingsService} from '../settings/settings.service';
import {ToastService} from 'ng-uikit-pro-standard';
import {TourData} from "../common/elements/elements.types";
import {LearningCenterService} from "../learning-center.service"

@Injectable({
  providedIn: 'root'
})

export class CommunicationsService {

  tempRefUrl = window.location.origin; //"https://ascent.aerostudies.com/" //for local testing

  selectedMemosState = [];
  searchTerm = "";
  network;
  tour: TourData[] = [];
  private _dataStore = new DataSource(this.http, this.SettingsService);
  memosDataStore = new BehaviorSubject(this._dataStore.getMemosStore()); //subscribed in memos.component
  networkSettingsStore = new BehaviorSubject(this._dataStore.store.network);
  studentMemosStore = new BehaviorSubject(this._dataStore.store.studentMemos)
  memosSearchDataStore = new BehaviorSubject(this._dataStore.getMemosSearchResults());
  memosFiltersStore = new BehaviorSubject(this._dataStore.getMemosFilters());
  // memosFilterCategories = new BehaviorSubject(this._dataStore.store.filters.category.data);
  memosDataFilterStore = new BehaviorSubject(this._dataStore.getFilteredResults());
  memosConfirmationMessages = new BehaviorSubject(this._dataStore.getConfirmationMessages())
  memoById = new BehaviorSubject(this._dataStore.getMemoStore())
  createMemoInfoStepStore = new BehaviorSubject(this._dataStore.getInfoText());
  progressStore = new BehaviorSubject(this._dataStore.getProgress());

  constructor(
    private http: HttpClient,
    public globals: SystemGlobalsService,
    private SettingsService: SettingsService,
    private toast: ToastService,
    private _learningCenterService: LearningCenterService
  ) {
    this.setTourData();
    this.getNetworkSettings();
    this._dataStore.fetchAllconfirmationMessages((confirm) => {
      this.memosConfirmationMessages.next(confirm)
    });
  }

  getAllMemos(callback?) {

    this._dataStore.fetchAllMemos((m) => {
      this.broadcastMemoStoreChange(this._dataStore.getMemosStore());
      if (callback) {
        callback(m)
      }
    }, true);
  }

  fetchStudentMemos() {
    setTimeout(() => {
      this._dataStore.getAllPersonalMemos((memos) => {
        this.studentMemosStore.next(memos)
      })
    }, 2000)
  }

  getStudentMemosFromStore() {
    return this._dataStore.store.studentMemos
  }

  areMemoFiltersLoaded(): boolean {
    return this._dataStore.memoCategoriesLoaded() && this._dataStore.memoPrioritiesLoaded();
  }

  getMemoCategoryName(categoryId: number) {
    let category = this._dataStore.getMemoCategory(categoryId);

    if (category) return category.category;
    else return null;
  }

  getMemoPriorityName(priorityId: number) {
    let priority = this._dataStore.getMemoPriority(priorityId);

    if (priority) return priority.priority;
    else return null;
  }

  getNetworkSettings() {
    this._dataStore.fetchNetworkSettings((n) => {
      this.setAddress(n, () => {
        this.networkSettingsStore.next(n)
      });

    })
  }

  getConfirmationMessages() {
    return this._dataStore.store.confirmation;
  }

  getNetworkStore() {
    return this._dataStore.store.network
  }

  getGlobals() {
    return this.globals;
  }

  getMemoById(id, callback) {
    this._dataStore.fetchMemoById(id, (memo) => {
      this.memoById.next(memo);
      callback(memo);
    });
  }

  readMemo(memoId: number, callback: Function) {
    this._dataStore.readMemo(memoId, (memo) => {
      this.memoById.next(memo);
      callback(memo);
    });
  }

  acceptMemo(memoAcceptData: MemoAcceptData, callback: Function) {
    this._dataStore.acceptMemo(memoAcceptData, () => callback());
  }

  getCurrentMemo() {
    return this._dataStore.getMemoStore();
  }

  getGroupMemosIntoCategoriesForResend(): Observable<any> {
    return this._dataStore.categoryGroupsAndCountEmitter;
  }

  getGroupMemosIntoCategoriesForResendFromStore() {
    return this._dataStore.store.groupMemosIntoCategories;
  }

  getAllMemosFromStore() {
    this._dataStore.store.memos;
  }

  broadcastMemoStoreChange(store) {
    this.memosDataStore.next(store);
  }

  broadcastMemoByIdStoreChange(store) {
    this.memoById.next(store);
  }

  broadcastMemoFiltersChange(store) {
    this.memosFiltersStore.next(store)
  }

  broadcastMemosSearchResultsStoreChange(store) {
    this.memosSearchDataStore.next(store)
  }

  broadcastConfirmationStoreChange(message) {
    this.memosConfirmationMessages.next(message)
  }

  broadcastMemosFilteredResults(store) {
    this.memosDataFilterStore.next(store);
  }

  broadcastCreateMemoInfoText(store) {
    this.createMemoInfoStepStore.next(store);
  }

  broadcastProgressChange(store) {
    this.progressStore.next(store);
  }

  removeMemosStore(callback) {
    let memosState = this._dataStore.store.memos.filter((curr, inx) => {
      return !this.selectedMemosState.includes(curr)
    });

    //httpcall.subscribe()...
    //todo: we need the copied data back from the server response here
    // this is just a placeholder.

    this.selectedMemosState = [];
    this._dataStore.setMemosStore(memosState)

    this.broadcastMemoStoreChange(this._dataStore.store.memos);

    callback();

  }

  copyMemoStore(callback) {

    //httpcall.subscribe()...
    //todo: we need the copied data back from the server response here
    // this is just a placeholder.

    this.selectedMemosState.forEach((curr) => {
      this._dataStore.store.memos[(this._dataStore.store.memos.indexOf(curr))]["selected"] = false;
      this._dataStore.store.memos.unshift(curr);
    })
    this.selectedMemosState = [];
    this.broadcastMemoStoreChange(this._dataStore.getMemosStore());

    callback();
  }

  setSearchResults(term) {
    // 'clear-search-field' term is to reset search data
    if (term == "clear-search-field") {
      this.selectedMemosState = [];

      this.broadcastMemoStoreChange(this._dataStore.getMemosStore());

    } else {
      //this can be ajax
      this.searchTerm = term.toString();
      if (term.length > 2) {
        this._dataStore.store.searchResults = this._dataStore.store.memos.filter((e) => e["Memo"]?.name?.toString().toLocaleLowerCase().includes(term.toLocaleLowerCase()));
        this.broadcastMemosSearchResultsStoreChange(this._dataStore.getMemosSearchResults());
      }
    }
  }

  setFilteredResults(payload) {
    this._dataStore.store.filteredResults = payload;

  }

  setMomoRecipientsStore(payload) {
    let converted: Array<any> = Array.from(payload);

    this._dataStore.store.memo.MemoUserLink = converted.reduce((accum, curr) => {
      accum.push({userID: curr["id"]})
      return accum;
    }, [])

  }

  setSelectedMemosState(payload) {
    this.selectedMemosState = payload;
  }

  getSelectedMemosState() {
    return this.selectedMemosState;
  }

  resetMemosSelected() {
    this.selectedMemosState = [];
  }

  getStore() {
    return this._dataStore.store;
  }

  getCategories() {
    return this._dataStore.getMemosCategories()
  }

  remapMemosFromFlatArray(flatarray) {

    let formatedArr = [];
    flatarray.forEach((elem) => {
      formatedArr.push({Memo: elem, MemoCategory: {category: "Operations Update"}, MemoGroups: []})
    })

    let store = this._dataStore.getMemosStore();
    let found = []

    formatedArr.map((curr, inx) => {
      found.push(store.find((e) => e["Memo"].memoID == curr["Memo"].memoID));
    });

    return found;
  }

  setFilteredData(payload) {

    this._dataStore.setFilteredResults(this.remapMemosFromFlatArray(payload));
    this.broadcastMemosFilteredResults(this._dataStore.getFilteredResults());
  }

  resetFilteredData() {
    this.broadcastMemoStoreChange(this._dataStore.store.memos)
  }

  filterBasedOnQueryStrings(string) {
    this._dataStore.fetchFilterMemos(string, () => {
      this.broadcastMemosFilteredResults(this._dataStore.getFilteredResults());
    })
  }

  getFilteredResultsFromStore() {
    return this._dataStore.getFilteredResults();
  }

  //steps for creating memos
  setInfoText(value: infoStepType) {
    this._dataStore.store.currentInfoText = {title: value.title, text: value.text};
    this.broadcastCreateMemoInfoText(this._dataStore.store.currentInfoText);
  }

  setProgress(value: infoStepType) {
    this._dataStore.store.progress = {title: value.title, text: value.text};
    this.broadcastProgressChange(this._dataStore.store.progress);
  }

  setCreateData(isLastStep: boolean = false, callback?) {
    // TODO: Replace defaultNewMemo: Need to send memo data, 2nd param is whether to send memo or not (Always last step)


    this._dataStore.saveMemo(this._dataStore.getMemoStore(), isLastStep, (memo) => {
      this.broadcastMemoByIdStoreChange(memo);

      if (isLastStep) {
        this._dataStore.store.memo = new memoType(defaultNewMemo);
        this._dataStore.store.memo.Memo.id = null;
        this._dataStore.store.memo.Memo.memoID = null;
      }
    });

    callback();
  }

  setCurrentMemoItemsStore(memo) {
    this._dataStore.setCurrentMemoItems(memo, (store) => {
      this.memoById.next(store);
    });
  };

  setSettingsData(settings) {
    this._dataStore.store.memo = settings;
    //todo: http call
  }

  handleEditItemsFromModal(payload) {
//handles events from edit modals
    switch (payload['type']) {

      case 'categories' :
        //full collection is being pushed and replaced from the parent
        if (payload['delete'].id !== null) {

          this._dataStore.deleteCategory(payload['delete'].id, payload['delete'].updatedItems, () => {
            //notify components of change to data
            this.broadcastMemoFiltersChange(this._dataStore.getMemosFilters())
          });
        }
        if (payload['add'].length > 0) {
          this._dataStore.addCategories(payload['add'], (addedCategoryWithDetails) => {
            //we're replacing the categories

            payload['collection'].map((c) => {
              if (c.id == 0) {
                addedCategoryWithDetails.forEach((r) => {
                  if (c.name.toString() == r.category.toString()) {
                    c.id = r.categoryID
                  }
                })
              }
            })

            this._dataStore.setCategoriesStore(payload['collection']);
            //notify components of change to data
            this.broadcastMemoFiltersChange(this._dataStore.getMemosFilters());

          });
        }

        //rename/update Categories
        this._dataStore.updateCategories(payload['collection'], (error) => {
          if (error) {
            this.toast.error('Error Updating Categories', 'Error', {
              positionClass: 'md-toast-bottom-left',
              toastClass: 'opaque'
            })
          }
        })

        break;
      case 'priorities' :

        if (payload['delete'].id !== null) {
          this._dataStore.deletePriority(payload['delete'].id, payload['delete'].updatedItems, () => {
            this.broadcastMemoFiltersChange(this._dataStore.getMemosFilters())
          });
        }

        if (payload['add'].length > 0) {
          this._dataStore.addPriorities(payload['add'], (prioritiesWithDetails) => {
            payload['collection'].map((c) => {
              if (c.id == 0) {
                prioritiesWithDetails.forEach((r) => {
                  if (c.name.toString() == r.priority.toString()) {
                    c.id = r.priorityID
                  }
                })
              }
            })
            this._dataStore.setPriorityStore(payload['collection']);
            this.broadcastMemoFiltersChange(this._dataStore.getMemosFilters());
          });
        }

        //rename/update Priorities
        this._dataStore.updatePriorities(payload['collection'], (error) => {
          if (error) {
            this.toast.error('Error Updating Priorities', 'Error', {
              positionClass: 'md-toast-bottom-left',
              toastClass: 'opaque'
            })
          }
        })

        break;
      case 'confirm' :

        this._dataStore.saveConfirmationMessages(payload['collection'], (error) => {
          if (error) {
            this.toast.error('Error Updating Messages', 'Error', {
              positionClass: 'md-toast-bottom-left',
              toastClass: 'opaque'
            })
          } else {
            this.broadcastConfirmationStoreChange(this._dataStore.getConfirmationMessages());
          }
        })
    }
  }

  setAddress(n, callback?) {

    this._learningCenterService.getUserAddress(this.globals.constants.userID).subscribe((f) => {
        let address = ""
        let address2 = (f.address2) != '' ? `\n${f.address2}` : "";

        if (f.address1 == "") {
          address = `${n['Network']['network_name']}\n`
        } else {
          address = `${n['Network']['network_name']}\n${f.address1}${address2}\n${f.city}\n${f.country}`
        }

        this._dataStore.store.memo.Memo.address = address;

        callback(address);

      },
      (error) => {
        this._dataStore.store.memo.Memo.address = `${n['Network']['network_name']}\n`
        callback(this._dataStore.store.memo.Memo.address);

      }
    );
  }

  getAddress() {
    return this._dataStore.store.memo.Memo.address
  }

  resetCurrentMemo() {
    this._dataStore.resetCurrentMemo();
  }

  resetStoreIds(){
    this._dataStore.store.memo.Memo.memoID = null;
    this._dataStore.store.memo.Memo.id = null;
    this._dataStore.store.memo.Memo.sent = 0

  }

  secondsMinutesConversion(time) {
    let minutes = Math.floor(time / 60);
    let seconds = time - minutes * 60;
    return {seconds: seconds, minutes: minutes}
  }

  calculateMemoNumberNum(catId: string, callback?) {

    this._dataStore.fetchAllMemos((memos) => {
      let numArr = [];
      memos.forEach((m) => {
        if (m.Memo.categoryID == catId) {
          numArr.push(m.Memo.num);
        }
      })

      if (numArr.length > 0) {
        callback(Math.max(...numArr) + 1);
      } else {
        callback(0);
      }
    }, true)

  }

  deleteMemo(memo) {

    this._dataStore.deleteMemo(memo, (store) => {
      if (store) {
        this.toast.success('Memo Deleted', 'Success', {positionClass: 'md-toast-bottom-left', toastClass: 'opaque'});

        this.memosDataStore.next(store);

      } else {
        this.toast.error('Error Deleting Memo', 'Error', {positionClass: 'md-toast-bottom-left', toastClass: 'opaque'})
      }
    })
  }

  archiveMemo(memo) {
    this._dataStore.archiveMemo(memo, (store) => {
      if (store) {
        this.toast.success('Memo Archived', 'Success', {positionClass: 'md-toast-bottom-left', toastClass: 'opaque'});
        this.memosDataStore.next(store);
      } else {
        this.toast.error('Error Archiving Memo', 'Error', {positionClass: 'md-toast-bottom-left', toastClass: 'opaque'})
      }
    }, false)
  }

  unarchiveMemo(memo) {
    this._dataStore.archiveMemo(memo, (store) => {
      if (store) {
        this.toast.success('Memo Un-Archived', 'Success', {
          positionClass: 'md-toast-bottom-left',
          toastClass: 'opaque'
        });
        this.memosDataStore.next(store);
      } else {
        this.toast.error('Error Un-Archiving Memo', 'Error', {
          positionClass: 'md-toast-bottom-left',
          toastClass: 'opaque'
        })
      }
    }, true)
  }

  resendMemos(memos, recipients, callback) {

    let payload: MemoResendData = {
      memoCategories: [],
      studentGroups: [],
      students: [],
      memos: []

    }

    memos.forEach((m) => {
      payload.memos.push(m.Memo.memoID);

    })

    recipients.forEach((r) => {
      payload.students.push(r.id);

    })

    this._dataStore.resendMemos(payload, (success) => {

      callback(success)
    });

  }

  setSelectedForReSendMemosStore(value) {
    this._dataStore.store.selectedForReSendMemos = value;
  }

  setGroupMemosIntoCategoriesStore(value) {
    this._dataStore.store.groupMemosIntoCategories = value;
  }

  getSelectedForReSendMemosStore() {
    return this._dataStore.store.selectedForReSendMemos;
  }

  momoBypass() {
    let url = '/memos/emergency_bypass/1';

    sessionStorage.setItem("memobypass", "1");

    this.http.post(url, true).subscribe();
    setTimeout(() => window.location.href = "/main/safety-reports/reports", 1500);
  }

  viewPdf() {
    let url = "/memos/perform/" + this._dataStore.store.memo.Memo.memoID + "/pdf";
    window.open(url, '_blank')
  }

  setDefaultConfirmMessage(message) {
    this._dataStore.store.memo.Memo.confirmText = message;
  }

  setTourData() {
    this.tour = [
      {
        type: "image",
        src: "/img/help/tours/tour_memos_1.jpg",
        title: "We updated the look and feel across all memos sections",
        body: "Don't worry, we have not removed any features that you're used to. This update will help you navigate and identify your memos better than before."
      }, {
        type: "image",
        src: "/img/help/tours/tour_memos_2.gif",
        title: "Easily find your memos",
        body: "New filters section lets you easily select multiple filter options. Use the search field to find exact memo, or sort results by clicking on the table header."
      },
      {
        type: "image",
        src: "/img/help/tours/tour_memos_4.gif",
        title: "New memos preview",
        body: "Memos preview now includes simple analytics, re-sending and archiving options as well as detailed memo info and " +
          "the ability to create a new version of the memo."
      },
      {
        type: "image",
        src: "/img/help/tours/tour_memos_3.gif",
        title: "Updated memo creation process",
        body: "We cleaned-up the creating a memo process by separating it into 3 steps (Create, Content, Recipients). You can now find memo settings by clicking 'Memos Setting'."
      },
      {
        type: "image",
        src: "/img/help/tours/tour_memos_5.gif",
        title: "New Verify questions feature",
        body: "You can now add multiple verification questions to your memo. This will test the readers knowledge of the memo before proceeding."
      },
      {
        type: "",
        src: "",
        title: "Questions or Concerns?",
        body: "If you have questions in regards to the new memo system, please submit a help request and we'll get back to you soon."
      }
    ]
  }

}


